import { render, staticRenderFns } from "./daochuMonth.vue?vue&type=template&id=2b72cef4&scoped=true&"
import script from "./daochuMonth.vue?vue&type=script&lang=js&"
export * from "./daochuMonth.vue?vue&type=script&lang=js&"
import style0 from "./daochuMonth.vue?vue&type=style&index=0&id=2b72cef4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b72cef4",
  null
  
)

export default component.exports